import APIServer from "./APIServer";


export default class SearchAPI extends APIServer { 

    async search(zoneSlug, {responseType="event", tags=null, page=1} = {}) { 
        return await super.get(`/search?zone_slug=${zoneSlug}&resp_type=${responseType}&tags=${tags}&page=${page}`);
    }
}